export const AnonymizationRepositoryToken = Symbol('AnonymizationRepositoryToken');
export const AnonymizationDataRepositoryToken = Symbol('AnonymizationDataRepositoryToken');
export const AnonymizationDataToken = Symbol('AnonymizationDataToken');
